import { ManagerRights } from './settings.model';
import { SdSectionKey } from './sd-permissions.model';

export type SdDestination = SdSectionKey | 'managers' | 'rankings' | 'invite-links' | 'reports';

export function canOpenSdDestination(rights: ManagerRights | undefined, destination: SdDestination, rankingsEnabled: boolean): boolean {
  if (!rights) return false;
  if (destination === 'managers') return rights.canManageManagers === true;
  if (destination === 'rankings') return rankingsEnabled;
  if (destination === 'invite-links') return rights.sections.invites === true;
  if (destination === 'reports') return rights.sections.finances === true;
  return rights.sections[destination] === true;
}

export function firstSdDestination(rights: ManagerRights | undefined, rankingsEnabled: boolean): SdDestination | null {
  const destinations: SdDestination[] = ['invites', 'applications', 'residents', 'claims', 'properties', 'managers', 'finances', 'rankings'];
  return destinations.find(destination => canOpenSdDestination(rights, destination, rankingsEnabled)) ?? null;
}
